export const navLinks = [
  { label: 'Expertise', href: '#expertise' },
  { label: 'Approach', href: '#approach' },
  { label: 'Focus', href: '#focus' },
  { label: 'Contact', href: '#contact' },
];

export const movePanels = [
  { n: '01', title: 'Local visibility', text: 'Be present across high-intent local searches.' },
  { n: '02', title: 'Maps presence', text: 'Help customers verify and reach the right location.' },
  { n: '03', title: 'Qualified enquiries', text: 'Make phone calls, messages and booking intent easier to act on.' },
  { n: '04', title: 'Conversion experience', text: 'Reduce friction between discovery and contact.' },
];

export const services = [
  { n: '01', title: 'Local SEO', text: 'Optimize discoverability across location-specific searches and on-site pages.', tag: 'Search' },
  { n: '02', title: 'Maps & Business Profiles', text: 'Strengthen Google Business Profile content, clarity and consistency.', tag: 'Maps' },
  { n: '03', title: 'Search Campaigns', text: 'Reach customers actively looking for relevant services.', tag: 'Paid' },
  { n: '04', title: 'Conversion & Measurement', text: 'Make the website clearer, faster and easier to act on, then measure what matters.', tag: 'Action' },
];

export const phases = [
  { n: '01', title: 'Discover', text: 'Audit local demand, search surfaces and website friction.' },
  { n: '02', title: 'Prioritize', text: 'Choose the opportunities closest to valuable customer intent.' },
  { n: '03', title: 'Improve', text: 'Refine pages, profiles, campaigns and conversion paths.' },
  { n: '04', title: 'Measure', text: 'Review visibility, leads and learning; keep improving.' },
];

export const focusAreas = [
  { n: 'A', title: 'Local services', text: 'Be easy to find when nearby customers need help.', need: 'Typical need: appearing in nearby searches at the moment someone needs help, and making the call easy.' },
  { n: 'B', title: 'Independent practices', text: 'Communicate expertise, reassurance and a clear next step.', need: 'Typical need: trustworthy profiles and pages that answer questions before the first appointment.' },
  { n: 'C', title: 'Multi-location brands', text: 'Maintain consistent local information without losing the human scale.', need: 'Typical need: accurate details for every location, with pages that still feel local.' },
];

export const signals = [
  { n: '01', title: 'Local search visibility', text: 'Where you appear for nearby searches that carry real intent, by service and area.', width: '100%' },
  { n: '02', title: 'Business profile interactions', text: 'Calls, direction requests and website visits started from your business profile.', width: '78%' },
  { n: '03', title: 'Qualified enquiries', text: 'Contacts that match the services and locations you actually serve.', width: '56%' },
  { n: '04', title: 'Conversion performance', text: 'How smoothly people move from first visit to first contact — and where they drop off.', width: '38%' },
];

export const heroLegend = [
  { label: 'Search activity', tone: 'dot' },
  { label: 'Customer action', tone: 'ink' },
  { label: 'Visibility signal', tone: 'accent' },
];